<template>
  <div class="root">
    <div class="typeList">
      <div
        @click="updeatType(index)"
        v-for="(data, index) in typeList"
        :key="index"
        class="typeDev"
        :class="{ typeDevAct: typeIndex == index }"
        :style="{
          'background-color': typeIndex == index ? '#2187ff' : '',
        }"
      >
        <!-- <div
        @click="updeatType(index)"
        v-for="(data, index) in typeList"
        :key="index"
        class="typeDev"
        :class="{ typeDevAct: typeIndex == index }"
        :style="{
          'background-color':
            typeIndex == index
              ? cityDetail.cityName == '华龙区'
                ? '#6681ea'
                : '#2187ff'
              : '',
        }"
      > -->
        <!-- <span
          class="typeSpan"
          :style="{
            color:
              typeIndex == index
                ? '#fff'
                : cityDetail.cityName == '华龙区'
                ? '#6681ea'
                : '#2187ff',
          }"
          :class="{ typeSpanAct: typeIndex == index }"
          > -->
        <span
          class="typeSpan"
          :style="{
            color: typeIndex == index ? '#fff' : '#2187ff',
          }"
          :class="{ typeSpanAct: typeIndex == index }"
          >{{ data.label }}</span
        >
      </div>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        margin: 20px 0 0 40px;
        font-size: 26px;
        font-weight: 600;
      "
    >
      <span style="margin-right: 10px">项目状态:</span>
      <div
        v-for="(data, index) in statusList"
        :key="index"
        style="margin-right: 10px; cursor: pointer"
        @click="selectStatus(index)"
        :class="{ statusAct: statusIndex == index }"
        :style="{
          color: statusIndex == index ? '#2187ff' : '#000',
        }"
      >
        <!-- <div
        v-for="(data, index) in statusList"
        :key="index"
        style="margin-right: 10px; cursor: pointer"
        @click="selectStatus(index)"
        :class="{ statusAct: statusIndex == index }"
        :style="{
          color:
            statusIndex == index
              ? cityDetail.cityName == '华龙区'
                ? '#6681ea'
                : '#2187ff'
              : '#000',
        }"
      > -->
        <span>{{ data.status }}</span>
      </div>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        padding: 0 10px;
        font-size: 20px;
        margin: 20px 0px 0px 30px;
        font-size: 20px;
      "
    >
      <span>选择区域</span>
      <div class="select" @click="showDeptList = !showDeptList">
        <span>{{ getDeptName(deptId) }}</span>
        <div :style="showDeptList ? {} : { display: 'none' }">
          <span
            @click="checkCity(city.deptId)"
            class="native"
            v-for="(city, index) in cityList"
            :key="index"
            >{{ city.deptName }}</span
          >
        </div>
      </div>
      <!-- <el-select
        style="width: 250px; padding: 0 10px"
        v-model="deptId"
        placeholder="请选择区域">
        <el-option
          :label="city.deptName"
          :value="city.deptId"
          v-for="(city, index) in cityList"
          :key="index">
        </el-option>
      </el-select> -->
      <span v-if="typeIndex != 2">选择面积</span>
      <div
        v-if="typeIndex != 2"
        class="select"
        @click="showAreaList = !showAreaList"
      >
        <span>{{ getAreaName(area) }}</span>
        <div :style="showAreaList ? {} : { display: 'none' }">
          <span
            class="native"
            @click="checkArea(index)"
            v-for="(area1, index) in areaList"
            :key="index"
            >{{ area1.label }}</span
          >
        </div>
      </div>
      <!-- <el-select
        style="width: 250px; padding: 0 10px"
        v-model="area"
        placeholder="请选择面积">
        <el-option
          :label="area1.label"
          :value="index"
          v-for="(area1, index) in areaList"
          :key="index">
        </el-option>
      </el-select> -->
      <span>关键字</span>
      <el-input
        style="width: 250px; padding: 0 10px"
        placeholder="请输入关键字"
        v-model="keyword"
      ></el-input>
      <el-button
        type="primary"
        size="medium"
        @click="updeatType(typeIndex, idx)"
        >搜索</el-button
      >
    </div>
    <div style="display: flex; flex-wrap: nowrap; flex: 1">
      <ul class="ul_left">
        <li
          v-for="(item, index) in typeList[typeIndex].li_bg"
          :key="index"
          @click="changeBg(index)"
        >
          <div
            v-show="index == idx"
            class="image"
            :style="{
              'background-color': '#2187ff',
            }"
          >
            <!-- <div
            v-show="index == idx"
            class="image"
            :style="{
              'background-color':
                cityDetail.cityName == '华龙区' ? '#6681ea' : '#2187ff',
            }"
          > -->
            <div style="text-align: center; flex: 1">
              <span style="color: #fff">{{ item.name }}</span>
            </div>
            <img :src="item.activeImg" alt />
          </div>
          <div
            v-show="index != idx"
            class="image"
            style="background-color: #fff; border: 1px solid #ddd"
            :style="{
              color: '#2187ff',
            }"
          >
            <!-- <div
            v-show="index != idx"
            class="image"
            style="background-color: #fff; border: 1px solid #ddd"
            :style="{
              color: cityDetail.cityName == '华龙区' ? '#6681ea' : '#2187ff',
            }"
          > -->
            <div style="text-align: center; flex: 1">
              <span>{{ item.name }}</span>
            </div>
            <img :src="item.lazyImg" alt />
          </div>
        </li>
      </ul>
      <div class="ul-right">
        <h1 style="margin-top: 35px" v-if="!xiangmuList.length">暂无数据</h1>
        <div class="xiangmu1" v-if="xiangmuList.length > 0">
          <XiangMuHuiXian
            v-if="xiangmuList.length && cityDetail.cityName == '辉县市'"
            :xiangmuList="xiangmuList"
            :type="typeList[typeIndex].type"
          />
          <XiangMu
            v-else-if="xiangmuList.length"
            :xiangmuList="xiangmuList"
            :type="typeList[typeIndex].type"
          />
          <!-- <h3 v-else style="font-size: 24px">暂无数据</h3> -->
        </div>
        <div v-if="xiangmuList.length > 0">
          <!--  @size-change="handleSizeChange" -->
          <el-pagination
            prev-text="上一页"
            next-text="下一页"
            @current-change="handleCurrentChange"
            :page-size="pagesize"
            :current-page="currentPage"
            @prev-click="prevNum"
            @next-click="nextNum"
            layout="prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import XiangMu from '../components/Home/XiangMu.vue'
import XiangMuHuiXian from '../components/Home/XiangMu_辉县版本.vue'
import { getProList, outProjectList } from '../api/交易项目'
import { getInvitationList } from '../api/招投标'
import { getNeedProjectList } from '../api/产权需求'
import { Checkbox } from 'element-ui'
import { cityDetail } from '../util/mainOption'
import { getTownList } from '../api/Head'
export default {
  components: {
    XiangMu,
    XiangMuHuiXian,
  },
  data () {
    return {
      idx: 0,
      deptId: '',
      showDeptList: false,
      keyword: '',
      area: '0',
      showAreaList: false,
      cityList: [],
      areaList: [
        {
          label: '全部',
        },
        {
          label: '0 ~ 10亩',
        },
        {
          label: '10 ~ 100亩',
        },
        {
          label: '100 ~ 200亩',
        },
        {
          label: '200 ~ 500亩',
        },
        {
          label: '500亩以上',
        },
      ],
      areaList1: [
        {
          areaBegin: '0',
          areaEnd: '10000',
        },
        {
          areaBegin: '0',
          areaEnd: '10',
        },
        {
          areaBegin: '10',
          areaEnd: '100',
        },
        {
          areaBegin: '100',
          areaEnd: '200',
        },
        {
          areaBegin: '200',
          areaEnd: '500',
        },
        {
          areaBegin: '500',
          areaEnd: '10000',
        },
      ],
      titles: [],
      //   每页数据条数
      pagesize: 9,
      currentPage: 1,
      inputpage: 1,
      // dm: "",
      number: '',
      xiangmuList: [],
      total: 0,
      code: 0,
      typeIndex: 0,
      statusIndex: 0,
      statusStr: '',
      statusList: [],
    }
  },
  created () {
    window.addEventListener('click', (e) => {
      if (!(e.target.className == 'native' || e.target.className == 'select')) {
        this.showDeptList = false
        this.showAreaList = false
      }
    })
  },
  mounted () {
    this.updeatType(this.$route.query.index, this.$route.query.idx)
    getTownList().then((res) => {
      console.log(res)
      this.cityList = [
        {
          deptName: this.cityDetail.cityName,
          deptId: this.cityDetail.deptId,
        },
        ...res.data.data,
      ]
    })
    this.deptId = this.$route.query.dm
      ? this.$route.query.dm
      : this.cityDetail.deptId
    if (this.$route.query.statusIndex) {
      this.selectStatus(this.$route.query.statusIndex)
    } else {
      this.selectStatus()
    }
    // console.log(this.$route.query)
  },
  computed: {},
  watch: {},
  methods: {
    setProjectStatusList (type) {
      if (type == "1") {
        this.statusList = cityDetail.invitationStatusList ? [
          {
            status: '全部',
            statusStr: (cityDetail.projectAllStatus || '2,3,4,5,6,7,8,9,10,11'),
          },
          ...cityDetail.invitationStatusList
        ] : [
          {
            status: '全部',
            statusStr: (cityDetail.projectAllStatus || '2,3,4,5,6,7,8,9,10,11'),
          },
          {
            status: '公示中',
            statusStr: '2',
            statusImg: require('@/assets/img/公示中.png'),
            statusImg1: require('@/assets/img/公示中1.png'),
          },
          {
            status: '报名中',
            statusImg: require('@/assets/img/报名中.png'),
            statusImg1: require('@/assets/img/报名中1.png'),
            statusStr: '4',
          },
          {
            status: '竞价中',
            statusImg: require('@/assets/img/竞价中.png'),
            statusImg1: require('@/assets/img/竞价中1.png'),
            statusStr: '6',
          },
          {
            status: '已结束',
            statusImg: require('@/assets/img/已成交.png'),
            statusImg1: require('@/assets/img/已成交1.png'),
            statusStr: '5,10',
          },
        ]
      } else if (type == "2") {
        this.statusList = cityDetail.outStatusList ? [
          {
            status: '全部',
            statusStr: (cityDetail.projectAllStatus || '2,3,4,5,6,7,8,9,10,11'),
          },
          ...cityDetail.outStatusList
        ] : [
          {
            status: '全部',
            statusStr: (cityDetail.projectAllStatus || '2,3,4,5,6,7,8,9,10,11'),
          },
          {
            status: '公示中',
            statusStr: '2',
            statusImg: require('@/assets/img/公示中.png'),
            statusImg1: require('@/assets/img/公示中1.png'),
          },
          {
            status: '报名中',
            statusImg: require('@/assets/img/报名中.png'),
            statusImg1: require('@/assets/img/报名中1.png'),
            statusStr: '4',
          },
          {
            status: '竞价中',
            statusImg: require('@/assets/img/竞价中.png'),
            statusImg1: require('@/assets/img/竞价中1.png'),
            statusStr: '6',
          },
          {
            status: '已成交',
            statusImg: require('@/assets/img/已成交.png'),
            statusImg1: require('@/assets/img/已成交1.png'),
            statusStr: '7,8,9',
          },
        ]
      } else if (type == "3") {
        this.statusList = cityDetail.needStatusList ? [
          {
            status: '全部',
            statusStr: (cityDetail.projectAllStatus || '2,3,4,5,6,7,8,9,10,11'),
          },
          ...cityDetail.needStatusList
        ] : [
          {
            status: '全部',
            statusStr: (cityDetail.projectAllStatus || '2,3,4,5,6,7,8,9,10,11'),
          },
          {
            status: '公示中',
            statusStr: '2',
            statusImg: require('@/assets/img/公示中.png'),
            statusImg1: require('@/assets/img/公示中1.png'),
          },
          {
            status: '报名中',
            statusImg: require('@/assets/img/报名中.png'),
            statusImg1: require('@/assets/img/报名中1.png'),
            statusStr: '4',
          },
          {
            status: '竞价中',
            statusImg: require('@/assets/img/竞价中.png'),
            statusImg1: require('@/assets/img/竞价中1.png'),
            statusStr: '6',
          },
          {
            status: '已成交',
            statusImg: require('@/assets/img/已成交.png'),
            statusImg1: require('@/assets/img/已成交1.png'),
            statusStr: '7,8,9',
          },
        ]
      }
    },
    checkCity (deptId) {
      this.deptId = deptId
    },
    checkArea (index) {
      this.area = index
    },
    getDeptName (val) {
      for (let i = 0; i < this.cityList.length; i++) {
        if (this.cityList[i].deptId == val) {
          return this.cityList[i].deptName
        }
      }
    },
    getAreaName (val) {
      for (let i = 0; i < this.areaList.length; i++) {
        if (i == val) {
          return this.areaList[i].label
        }
      }
    },
    selectStatus (i = 0) {
      this.statusIndex = i
      this.statusStr = this.statusList[i].statusStr
      this.getProjectList()
    },
    // 翻页器上一页事件
    prevNum () {
      this.currentPage--
      this.getProjectList()
    },
    // 翻页器下一页事件
    nextNum () {
      this.currentPage++
      this.getProjectList()
    },
    // 点击大分类事件
    updeatType (i = 0, idx = 0) {
      this.currentPage = 1
      this.typeIndex = i
      this.idx = idx
      this.setProjectStatusList(this.typeList[this.typeIndex].type)
      if (this.typeList[this.typeIndex].li_bg.length) {
        this.getProjectList()
        return
      }
      getProList({ type: this.typeList[this.typeIndex].type }).then((res) => {
        this.typeList[this.typeIndex].li_bg = res.data.data
        this.typeList[this.typeIndex].li_bg.unshift({
          activeImg: require('@/assets/img/全部x1.png'),
          lazyImg: require('@/assets/img/全部x01.png'),
          mainImg: require('@/assets/img/全部.png'),
          code: "",
          name: '全部'
        })

        if (!this.typeList[this.typeIndex].li_bg.length) {
          this.xiangmuList = []
          this.total = 0
          return
        }
        this.getProjectList()
      })
    },
    getProjectList () {
      if (this.typeIndex == 2) {
        let inType = this.typeList[this.typeIndex].type
        getInvitationList({
          type: this.typeList[this.typeIndex].type,
          statusStr: this.statusStr,
          pageNum: this.currentPage,
          number: this.typeList[this.typeIndex].li_bg[this.idx]
            ? this.typeList[this.typeIndex].li_bg[this.idx].code
            : '',
          pageSize: this.pagesize,
          deptId: this.deptId,
          ...this.areaList1[this.area],
          keyword: this.keyword,
          searchValue: this.keyword,
          deptId: this.deptId,
        }).then((res) => {
          this.xiangmuList = res.data.rows
          this.total = res.data.total
          this.typeList[this.typeIndex].type = inType
        })
      } else if (this.typeIndex == 0) {
        outProjectList({
          type: this.typeList[this.typeIndex].type,
          pageNum: this.currentPage,
          pageSize: this.pagesize,
          number: this.typeList[this.typeIndex].li_bg[this.idx]
            ? this.typeList[this.typeIndex].li_bg[this.idx].code
            : '',
          deptId: this.deptId,
          statusStr: this.statusStr,
          ...this.areaList1[this.area],
          keyword: this.keyword,
          searchValue: this.keyword,
          deptId: this.deptId,
        }).then((res) => {
          this.xiangmuList = res.data.rows
          this.total = res.data.total
        })
      } else if (this.typeIndex == 1) {
        //   {
        //   type: this.typeList[this.typeIndex].type,
        //   pageNum: this.currentPage,
        //   pageSize: this.pagesize,
        //   number: this.typeList[this.typeIndex].li_bg[this.idx]
        //     ? this.typeList[this.typeIndex].li_bg[this.idx].code
        //     : '',
        //   statusStr: this.statusStr,
        //   params: this.areaList1[this.area],
        //   keyword: this.keyword,
        //   searchValue: this.keyword,
        //   deptId: this.deptId,
        //   pid: this.deptId,
        // }
        let form = new FormData()
        form.append('type', this.typeList[this.typeIndex].type)
        form.append('pageNum', this.currentPage)
        form.append('pageSize', this.pagesize)
        form.append(
          'number',
          this.typeList[this.typeIndex].li_bg[this.idx]
            ? this.typeList[this.typeIndex].li_bg[this.idx].code
            : ''
        )
        form.append('statusStr', this.statusStr)
        form.append('params[areaBegin]', this.areaList1[this.area].areaBegin)
        form.append('params[areaEnd]', this.areaList1[this.area].areaEnd)
        form.append('keyword', this.keyword)
        form.append('searchValue', this.keyword)
        form.append('deptId', this.deptId)
        form.append('pid', this.deptId)
        getNeedProjectList(form).then((res) => {
          this.xiangmuList = res.data.rows
          this.total = res.data.total
        })
      } else {
        this.xiangmuList = []
        this.total = 0
      }
    },
    changeBg (i) {
      this.idx = i
      this.getProjectList()
    },
    // 当前每夜多少条
    // handleSizeChange(size) {
    //   this.pagesize = size;
    // },
    // 当前页数
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.getProjectList()
    },
  },
}
</script>

<style scoped>
.select {
  border: 2px solid #ddd;
  position: relative;
  width: 250px;
  height: 40px;
  margin: 0 10px;
  display: flex;
  align-items: center;
  padding: 0px 8px;
  font-size: 16px;
  cursor: pointer;
}
.select > div {
  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  font-size: 16px;
  width: 100%;
  z-index: 99;
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 6px;
  max-height: 260px;
  overflow: auto;
}
.select > div > span {
  padding: 8px;
}
.select > div > span:hover {
  background-color: #ddd;
  cursor: pointer;
}

.zanwushuju {
  padding-top: 50px;
  font-size: 24px;
  /* border: #666666 1px solid; */
}

li {
  list-style: none;
}

.root {
  min-height: 1180px;
  margin: 0 auto;
  margin-bottom: 35px;
  width: 1860px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  opacity: 1;
  overflow: hidden;
  display: flex;
  flex-flow: column nowrap;
}

.ul_left {
  display: block;
  width: 260px;
  height: auto;
  /* float: left; */
  /* background-color: rebeccapurple; */
  padding: 40px 40px;
  list-style: inside none;
}

.ul_left > li {
  display: block;
  width: 260px;
  height: 92px;
  /* background-color: red; */
  margin-bottom: 10px;
  cursor: pointer;
}
.image {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  padding-right: 30px;
  font-size: 22px;
  font-weight: bold;
}
.ul-right {
  flex: 1;
  box-sizing: border-box;
  padding: 0 40px 0 0;
}

.xiangmu1 {
  width: 100%;
  padding-top: 35px;
}

.el-pagination {
  text-align: center;
}

.typeList {
  display: flex;
  align-items: center;
  padding: 40px 0 0 40px;
  /* justify-content: center; */
}

.typeDev {
  text-align: center;
  height: 60px;
  border: 1px solid #ddd;
  width: 300px;
  line-height: 60px;
  cursor: pointer;
}

.typeDevAct {
  text-align: center;
  height: 60px;
  border: 1px solid #ddd;
  width: 300px;
  line-height: 60px;
  cursor: pointer;
}

.typeSpan {
  color: #2187ff;
  font-size: 24px;
  font-weight: 600;
}

.typeSpanAct {
  color: #fff;
  font-size: 24px;
  font-weight: 600;
}

.statusAct {
  color: #2187ff;
}
</style>
